import React, { useEffect, useState } from "react";
import { SummaryImageProps } from "../../../interfaces";
import "./SummaryImage.scss";

const SummaryImage = (props: SummaryImageProps) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setImageLoaded(true);
    };
    img.onerror = () => {
      console.error("Error in loading image")
    }
    img.src =`${window.location.origin}/images/${props.url}`;
  }, [props.url]);

  return (
    <div
      className={
       props.customClass ?? "imageContainer"
      }
      data-testid="Test Image"
    >
      {imageLoaded && (
        <img
          alt={props.alt}
          src={ `${window.location.origin}/images/${props.url}`}
          height={props.height}
          width={props.width}
        />
      )}
    </div>
  );
};

export default SummaryImage;
